'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { markCurrentOrganisationSwitchSeen } from '@/lib/organisation-switch-marker';

const ORGANISATION_SWITCH_CHANNEL = 'wallet-organisation-switch';
const ORGANISATION_SWITCH_STORAGE_KEY = 'wallet-organisation-switch-event';

interface OrganisationSwitchEvent {
  organisationId: number;
  timestamp: number;
}

function createEvent(organisationId: number): OrganisationSwitchEvent {
  return {
    organisationId,
    timestamp: Date.now(),
  };
}

interface BroadcastOrganisationSwitchOptions {
  /**
   * BroadcastChannel also delivers to listeners in the sending tab, and the app reloads on that
   * message. Pass false when the caller navigates itself so the reload doesn't cancel it; other
   * tabs are still notified through the `storage` event, which never fires in the sending tab.
   */
  notifyCurrentTab?: boolean;
}

export function broadcastOrganisationSwitch(
  organisationId: number,
  { notifyCurrentTab = true }: BroadcastOrganisationSwitchOptions = {}
) {
  markCurrentOrganisationSwitchSeen();

  const event = createEvent(organisationId);

  if (typeof window === 'undefined') return;

  if (notifyCurrentTab && 'BroadcastChannel' in window) {
    const channel = new BroadcastChannel(ORGANISATION_SWITCH_CHANNEL);
    channel.postMessage(event);
    channel.close();
  }

  localStorage.setItem(ORGANISATION_SWITCH_STORAGE_KEY, JSON.stringify(event));
  localStorage.removeItem(ORGANISATION_SWITCH_STORAGE_KEY);
}

export function reloadAfterOrganisationSwitch(organisationId: number): void {
  const nextUrl = new URL(window.location.href);

  if (nextUrl.searchParams.has('organisationId')) {
    nextUrl.searchParams.set('organisationId', organisationId.toString());
  }

  window.history.replaceState(window.history.state, '', nextUrl.toString());
  window.location.reload();
}

export function subscribeToOrganisationSwitch(callback: () => void) {
  if (typeof window === 'undefined') return () => {};

  const channel =
    'BroadcastChannel' in window ? new BroadcastChannel(ORGANISATION_SWITCH_CHANNEL) : null;

  const handleChannelMessage = (message: MessageEvent<OrganisationSwitchEvent>) => {
    if (message.data?.organisationId) callback();
  };

  const handleStorageMessage = (event: StorageEvent) => {
    if (event.key !== ORGANISATION_SWITCH_STORAGE_KEY || !event.newValue) return;
    callback();
  };

  channel?.addEventListener('message', handleChannelMessage);
  window.addEventListener('storage', handleStorageMessage);

  return () => {
    channel?.removeEventListener('message', handleChannelMessage);
    channel?.close();
    window.removeEventListener('storage', handleStorageMessage);
  };
}
